<template>
  <div class="member-center">
    <div class="header">
      <div class="slider-banner banner">
        <swiper class="swiper-wrapper" :options="swiperVip" ref="mySwiper">
          <swiperSlide
            class="swiper-slide memberBg"
            :class="item.class"
            v-for="(item, index) in vipList"
            :key="index"
            :style="{ backgroundImage: 'url(' + item.image + ')' }"
          >
            <!--            <img :src="item.icon" />-->
            <div class="name">{{ item.name }}</div>
            <div class="discount">
              可享受商品折扣: {{ item.discount / 10 }}折<span
                class="iconfont icon-zhekou"
              ></span>
            </div>
            <div class="nav acea-row" v-if="item.grade == Number(currUserGrade)">
              <div
                class="item"
                v-for="(val, indexn) in vipComplete"
                :key="indexn"
              >
                <div class="num" v-if="val.realName!='累计签到'">{{ val.newNumber }}</div>
                <div v-if="val.realName!='累计签到'">{{ val.realName }}</div>

                <div class="num" v-if="val.realName=='累计签到'">
                  <!-- <span class="iconfont icon-zhekou"></span> -->
                  <!-- <span style="font-size:0.3rem" v-if="item.validDate==0">
                    永久
                  </span>
                  <span style="font-size:0.3rem" v-if="item.validDate!=0">
                    有效期:{{item.validDate}}天
                  </span> -->
                   <span style="font-size:0.3rem">
                    {{vipName}}
                  </span>
                </div>
                <div v-if="val.realName=='累计签到'">已解锁</div>
              </div>
            </div>
            <div class="lock" v-if="item.grade > currUserGrade">
              <span
                class="iconfont icon-quanxianguanlisuozi"
                @click="vipUpgrade"
              ></span
              >该会员等级尚未解锁
            </div>
            <div class="lock" v-if="Number(item.grade) < Number(currUserGrade)">
              <span class="iconfont icon-xuanzhong1"></span>已解锁更高等级
            </div>
          </swiperSlide>
        </swiper>
      </div>
    </div>
    <div class="wrapper">
      <div class="title acea-row row-between-wrapper">
        <div><span class="iconfont icon-jingyanzhi"></span>解锁会员升级</div>
        <!-- <div class="num">
          <span class="current">{{ taskCount }}</span
          >/{{ vipRequire.length }}
        </div> -->
      </div>
      <div class="list">
        <div class="" >
          <div class="">
            
            <img :src="buyimg" width="99.9%" @click="gotoClick()"/>
          </div>
          <!-- <div class="cu-progress">
            <div class="bg-red" :style="{ width: item.speed + '%' }"></div>
          </div> -->
        </div>
      </div>
      <!-- <div class="list">
        <div class="item" v-for="(item, index) in vipComplete" :key="index">
          <div class="top acea-row row-between-wrapper">
            <div class="name">
              {{ item.name
              }}<span
                class="iconfont icon-wenti"
                v-if="item.illustrate"
                @click="showGrow(item)"
              ></span>
            </div>
            <div>{{ item.finish ? "已满足条件" : "未满足条件" }}</div>
          </div>
          <div class="cu-progress">
            <div class="bg-red" :style="{ width: item.speed + '%' }"></div>
          </div>
          <div class="experience acea-row row-between-wrapper">
            <div>{{ item.taskTypeTitle }}</div>
            <div>
              <span class="num">{{ item.newNumber }}</span
              >/{{ item.number }}
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <div class="growthValue" :class="growthValue === false ? 'on' : ''">
      <div class="pictrue">
        <img src="@assets/images/value.jpg" /><span
          class="iconfont icon-guanbi3"
          @click="growthTap"
        ></span>
      </div>
      <div class="conter">
        {{ illustrate }}
      </div>
    </div> -->
    <!-- <div class="mask" :hidden="growthValue" @click="growthTap"></div> -->
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import { getVipInfo, getVipTask, setDetection } from "../../api/user";
export default {
  name: "Poster",
  components: {
    swiper,
    swiperSlide
  },
  props: {},
  data: function() {
    return {
      buyimg:"",
      vipName:"",
      // grade:"",
      productId:"",
      vipList: [], //等级列表
      vipRequire: [], //等级要求
      vipComplete: [], //完成情况
      taskCount: 0, //任务数
      currUserGrade: 0, //当前会员等级-用户
      tabGrade:0,       //当前TAB会员等级
      swiperVip: {
        speed: 1000,
        effect: "coverflow",
        slidesPerView: "auto",
        centeredSlides: true,
        // loop: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -20,
          depth: 100,
          modifier: 2,
          slideShadows: false
        },
        observer: true,
        observeParents: true
      },
      loading: false,
      growthValue: true,
      illustrate: "",
      activeIndex: 0
    };
  },
  watch: {
    vipList: function() {
      let that = this;
      if (that.vipList.length > 0) {
        that.vipList.forEach(function(item, index) {
          if (item.isClear === false) {
            that.swiper.slideTo(index);
            that.activeIndex = index;
            
    console.log("--0000222222222222222222220-===================")
            // console.log("11111222222222========"+item.grade)
            // that.grade = item.grade;
          }
        });
      }
    }
  },
  computed: {
    swiper() {
       console.log("--0000222221111111111112222222222222220-===================")
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted: function() {
    let that = this;
    //setDetection();
    // console.log("============================")
    that.getInfo();
    console.log("--00000-===================")

    
    that.swiper.on("slideChange", function() {
      
      that.activeIndex = that.swiper.activeIndex;

      // that.getTask();
      that.buyimg = that.vipList[that.activeIndex].buyimg;
      that.productId = that.vipList[that.activeIndex].productId;
      that.tabGrade = that.vipList[that.activeIndex].grade;

      // alert(that.tabGrade)
    });
  },
  methods: {
    vipUpgrade: function() {
      let that = this;
      setDetection().then(
        res => {
          that.$dialog.message(res.data);
          that.getInfo();
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    growthTap: function() {
      this.growthValue = true;
    },
    getInfo: function() {
      let that = this;
      // alert(111)

      this.$store.dispatch("USERINFO").then((res) => {

        console.log("---===11USERINFO11111======"+res.level)
          that.currUserGrade=res.level
          that.vipName=res.vipName
      
      });



      getVipInfo().then(
        res => {
          that.vipList = res.data.list;
          that.buyimg = that.vipList[0].buyimg;
          // that.productId = that.vipList[0].productId;
          // that.grade = that.vipList[0].grade;
          // alert(that.vipList[0].grade)

          that.vipRequire = res.data.task.list;
          that.vipComplete = res.data.task.task;
          that.taskCount = res.data.task.reachCount;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    getTask: function() {
      let that = this;
      getVipTask(that.vipList[that.activeIndex].id).then(
        res => {
          that.vipRequire = res.data.list;
          that.vipComplete = res.data.task;
          that.taskCount = res.data.reachCount;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    showGrow: function(item) {
      if (this.illustrate != item.illustrate) this.illustrate = item.illustrate;
      this.growthValue = false;
    },
    gotoClick(){
          let that = this;
// alert(this.currUserGrade+"==="+that.swiper.activeIndex)

that.tabGrade = that.vipList[that.swiper.activeIndex].grade;
// alert(that.tabGrade)

          if(this.currUserGrade==0){
              if(this.tabGrade==4){
                  this.$router.push({path: '/detail/4'});
              }else{
                  this.$router.push({path: '/detail/5'});
              }
          }else if(this.currUserGrade==4){
              if(this.tabGrade==4){
                  that.$dialog.message("您已解锁过该会员等级了");
              }else{
                  this.$router.push({path: '/detail/5'});
              }

          }else if(this.currUserGrade==5){
              if(this.tabGrade==4){
                  that.$dialog.message("您已解锁更高的会员等级了");
              }else{
                 that.$dialog.message("您已解锁过该会员等级了");
              }
          }


          // if(this.grade1==4){
          //     if(this.grade1==this.grade){
          //         that.$dialog.message("您已解锁过该会员等级了");
          //     }else if(this.grade1>this.grade){
          //         this.$router.push({path: '/detail/4'});
          //     }else if(this.grade1<this.grade){
          //         that.$dialog.message("您已解锁更高的会员等级了");
          //     }

          // }else if(this.grade1==5){
          //     if(this.grade1==this.grade){
          //         that.$dialog.message("您已解锁过该会员等级了");
          //     }else if(this.grade1>this.grade){
          //         this.$router.push({path: '/detail/5'});
          //     }
          // }

          // if(this.grade1==this.grade){
          //     //相同 ，说明解锁过了
          //     that.$dialog.message("您已解锁过该会员等级了");
          // }else if(this.grade1>this.grade){
          //     this.$router.push({path: '/detail/'+this.productId});
          // }else if(this.grade1<this.grade){
          //     that.$dialog.message("您的会员等级比这个高");
          //     // this.$router.push({path: '/detail/'+this.productId});
          // }


          // setDetection().then(
          //   res => {
          //     alert(this.grade1+"==="+res.data.grade)
          //         if(this.grade1==parseInt(res.data.grade)){
          //             //相同 ，说明解锁过了
          //             that.$dialog.message("您已解锁过该会员等级了");
          //         }else if(this.grade1>parseInt(res.data.grade)){
          //             this.$router.push({path: '/detail/'+this.productId});
          //         }else if(this.grade1<parseInt(res.data.grade)){
          //             that.$dialog.message("您的会员等级比这个高");
          //         }
          //   },
          //   err => {
          //     that.$dialog.message(err.msg);
          //   }
          // );

    }
  }
};
</script>
